import { ReportSection } from "../ReportSection";
import { ReportTable, type TableColumn } from "../ReportTable";
import { StatCard } from "../StatCard";

interface ActivityRow {
  userId: string;
  userName: string;
  tasksCompleted: number;
  actionsCompleted: number;
  meetingsAttended: number;
  notesCreated: number;
  ideasSubmitted: number;
  decisionsParticipated: number;
}

export function ActivitySummaryReport({ data }: { data: ActivityRow[] }) {
  const totals = data.reduce(
    (acc, r) => {
      acc.tasks += r.tasksCompleted;
      acc.actions += r.actionsCompleted;
      acc.meetings += r.meetingsAttended;
      acc.notes += r.notesCreated;
      acc.ideas += r.ideasSubmitted;
      return acc;
    },
    { tasks: 0, actions: 0, meetings: 0, notes: 0, ideas: 0 },
  );

  const cols: Array<TableColumn<ActivityRow>> = [
    { key: "userName", label: "Team Member" },
    { key: "tasksCompleted", label: "Tasks", align: "right" },
    { key: "actionsCompleted", label: "Actions", align: "right" },
    { key: "meetingsAttended", label: "Meetings", align: "right" },
    { key: "notesCreated", label: "Notes", align: "right" },
    { key: "ideasSubmitted", label: "Ideas", align: "right" },
    { key: "decisionsParticipated", label: "Decisions", align: "right" },
  ];

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-5">
        <StatCard label="Tasks Completed" value={totals.tasks} />
        <StatCard label="Actions Completed" value={totals.actions} />
        <StatCard label="Meetings Attended" value={totals.meetings} />
        <StatCard label="Notes Created" value={totals.notes} />
        <StatCard label="Ideas Submitted" value={totals.ideas} />
      </div>

      <ReportSection title="Activity by Team Member">
        <ReportTable columns={cols} rows={data} rowKey={(r) => r.userId} />
      </ReportSection>
    </div>
  );
}
